export default "__VITE_ASSET__c580b7ca__"